import React from "react";
import { NEEDS } from "@/data/needs";

const EstimateSlider = ({ needKey, value, onChange, t }) => {
  const set = Number.isFinite(value);
  const commit = (e) => onChange(needKey, Number(e.target.value));
  return (
    <div>
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-sm text-[var(--ink-soft)]">{t.lowSat}</span>
        <span
          className={`font-serif-title text-3xl ${set ? "text-[var(--gold)]" : "text-[var(--ink-soft)]"}`}
          data-testid={`estimated-${needKey}-value`}
        >
          {set ? value : "—"}
          <span className="text-base"> / 20</span>
        </span>
        <span className="text-sm text-[var(--ink-soft)]">{t.highSat}</span>
      </div>
      <input
        type="range"
        min={0}
        max={20}
        step={1}
        value={set ? value : 10}
        onChange={commit}
        onPointerUp={commit}
        onKeyUp={commit}
        onClick={commit}
        data-testid={`estimated-${needKey}-slider`}
        className={`w-full h-2 rounded-full appearance-none cursor-pointer accent-[var(--gold)] ${set ? "bg-[var(--gold-light)]" : "bg-[var(--beige)]"}`}
      />
    </div>
  );
};

export const EstimatedSatisfaction = ({ values, onChange, onPrev, onSubmit, lang, t }) => {
  const complete = NEEDS.every((n) => Number.isFinite(values[n.key]));

  return (
    <div className="animate-fade-up">
      <h2 className="font-serif-title text-3xl sm:text-4xl text-[var(--gold)] mb-4 text-center leading-tight">{t.estTitle}</h2>
      <div className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-6 sm:p-8 mb-8 text-[var(--ink)] leading-relaxed space-y-3">
        <p>{t.est1}</p>
        <p>{t.est2}</p>
        <p>{t.est3}</p>
      </div>

      <div className="space-y-4">
        {NEEDS.map((need) => (
          <div key={need.key} className="rounded-2xl border border-[var(--border)] bg-white/70 p-5 sm:p-6" data-testid={`estimated-${need.key}`}>
            <h3 className="font-serif-title text-2xl text-[var(--gold)] mb-2">{need.name[lang]}</h3>
            <p className="text-sm text-[var(--ink)] leading-relaxed mb-3">{need.definition[lang]}</p>
            <div className="rounded-xl bg-[var(--sand)] border border-[var(--border)] p-3 mb-5">
              <p className="text-xs uppercase tracking-[0.14em] text-[var(--ink-soft)] mb-1">{t.notLabel}</p>
              <ul className="list-disc pl-5 text-sm text-[var(--ink-soft)] space-y-0.5">
                {need.notList[lang].map((n, i) => (
                  <li key={`${need.key}-not-${i}`}>{n}</li>
                ))}
              </ul>
            </div>
            <EstimateSlider needKey={need.key} value={values[need.key]} onChange={onChange} t={t} />
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-8 no-print">
        <button onClick={onPrev} data-testid="btn-prev" className="px-6 py-3 rounded-full border border-[var(--gold)] text-[var(--gold)] font-medium hover:bg-[var(--gold)] hover:text-white transition-colors">
          {t.prev}
        </button>
        <button
          onClick={onSubmit}
          disabled={!complete}
          data-testid="btn-submit"
          className={`px-8 py-3 rounded-full font-medium transition-all ${complete ? "bg-[var(--gold)] text-white hover:brightness-105 shadow-sm" : "bg-[var(--beige)] text-[var(--ink-soft)] cursor-not-allowed"}`}
        >
          {t.seeResults}
        </button>
      </div>
      {!complete && <p className="text-center text-xs text-[var(--ink-soft)] mt-3 no-print">{t.completeSliders}</p>}
    </div>
  );
};
